import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@services/auth.service';
import dayjs from 'dayjs';
import { ToastService } from '@services/toast.service';
import { UserRole } from '../enums/user-role';

export const AuthGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const toastService = inject(ToastService);
  const router = inject(Router);

  if (
    authService.user() &&
    authService.user().role === UserRole.UNIT_ADMINISTRATOR &&
    dayjs().isAfter(authService.user().ttl)
  ) {
    authService.logOut();
    router.navigateByUrl('/login');
    toastService.showInfoMessage('Session has expired');
    return Promise.resolve(false);
  }
  if (authService.isUserAuthenticated()) {
    return Promise.resolve(true);
  }

  return router.navigateByUrl('/login');
};
